import { render, staticRenderFns } from "./assignExperts.vue?vue&type=template&id=6f1f3b9a&scoped=true&"
import script from "./assignExperts.vue?vue&type=script&lang=js&"
export * from "./assignExperts.vue?vue&type=script&lang=js&"
import style0 from "./assignExperts.vue?vue&type=style&index=0&id=6f1f3b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f3b9a",
  null
  
)

export default component.exports